import { Typography, styled } from "@mui/material";

export const Title = styled(Typography)`
  font-size: 32px;
  font-weight: 700;
  color: #333;
  text-align: center;
`;
